<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1"
                  @click="getDataForTable()"
                  icon="refresh"
                  tooltip="Ansicht aktualisieren"
                  hide-label></lx-btn>
          <lx-btn small classes="mr-1"
                  @click="showBlacklistDialog = true"
                  icon="mdi-account-plus"
                  tooltip="Patient zur Liste gesperrter Patienten hinzufügen"
                  hide-label></lx-btn>
        </div>

        <div class="flex layout-row mr-1 ml-3">
          <lx-search-field
            :placeholder="$t('BLACKLIST.TABLE.SEARCH_PLACEHOLDER')"
            dense
            v-model="tableObj.filterValue"
            :data-method="getDataForTable"
          ></lx-search-field>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;"
             :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="Blacklist"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :preventRowClick="true"
              :tableOptions="tableObj.options"
              :hideContextFilter="true"
              @changeOptions="changeTableOptions">

              <template v-slot:cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'whitelist'" style="height:35px;cursor:pointer;" class="layout-column layout-align-center-start">
                  <div @click="whitelistPatient($event, value.i)" class="layout-row layout-align-center-center">
                    <v-icon class="mr-1" :color="compColor.primeColor" style="font-size: 17px;">mdi-account-check</v-icon>
                    <label style="cursor: pointer;">{{ $t('BLACKLIST.TABLE.WHITELIST_PATIENT') }}</label>
                  </div>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'Blacklist'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>

    <blacklist-dialog
      :show-blacklist-dialog="showBlacklistDialog"
      @set-show-blacklist-dialog="setShowBlacklistDialog">
    </blacklist-dialog>
  </div>
</template>

<script>
import LxPagination from '../../components/lx_pagination/LxPagination'
import BlacklistDialog from '../../components/patients/BlacklistDialog'

export default {
  name: 'Blacklist',
  data () {
    return {
      tableObj: {
        loading: false,
        options: {
          sortBy: ['lastname'],
          sortDesc: [false]
        },
        filterValue: null,
        headers: [
          {
            text: 'Nachname',
            value: 'lastname',
            width: '200px',
            sortable: true
          },
          {
            text: 'Vorname',
            value: 'firstname',
            width: '200px',
            class: 'pinned',
            sortable: true
          },
          {
            text: 'AIS ID',
            value: 'ais_id',
            width: '150px',
            class: 'pinned',
            sortable: true
          },
          {
            text: 'Geschlecht',
            value: 'gender',
            width: '100px',
            class: 'text-center',
            renderer: 'gender'
          },
          {
            text: 'Gesperrt bis',
            value: 'until',
            width: '100px'
          },
          {
            text: '',
            value: '',
            renderer: 'whitelist'
          }
        ]
      },
      pagingOptions: {
        limit: 25,
        skip: 0,
        count: 0
      },
      items: [],
      isLoadingData: false,
      showBlacklistDialog: false
    }
  },
  components: {
    BlacklistDialog,
    LxPagination,
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * get list of all linked patients
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      if (this.tableObj.filterValue) {
        query.search = this.tableObj.filterValue
      }

      this.$http.get('/patients/blacklist/blacklisted?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.items = res.data.items || []
            this.pagingOptions.count = res.data.count || 0

            this.items.forEach(item => {
              if (item.isPermanentIgnored) {
                item.until = 'auf Weiteres'
                return
              }

              if (item.isIgnoredUntil !== null) {
                item.until = this.$options.filters['formatDate'](item.isIgnoredUntil, 'DD.MM.YYYY')
              }
            })
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    /**
     * Trigger method to remove patient from blacklist
     */
    whitelistPatient (event, params) {
      if (params && params._id) {
        if (this.tableObj.loading || this.isLoadingData) return
        this.isLoadingData = true

        this.$http.put('/patients/blacklist', {id: params._id, type: 'remove'})
          .then(() => {
            this.isLoadingData = false
            this.getDataForTable()
            this.NotifySystem(this.$t('BLACKLIST.NOTIFICATIONS.WHITELIST_SUCCESS'))
          })
          .catch(() => {
            this.NotifyError(this.$t('BLACKLIST.NOTIFICATIONS.WHITELIST_ERROR'))
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      event.stopPropagation()
    },

    /**
     * Open or close modal with black list dialog
     */
    setShowBlacklistDialog () {
      this.showBlacklistDialog = !this.showBlacklistDialog

      if (!this.showBlacklistDialog) {
        this.getDataForTable()
      }
    },
  },
  watch: {
    '$route' (to) {
      if (to.name === 'Blacklist') {
        this.getDataForTable()
      }
    }
  }
}
</script>
